import { ApiError, createApiClient, Result, wrapper } from "@/api/base";
import { LaravelPaginatedCollection } from "@/types/collections";

// Import the necessary types from our DTOs
import ABTestDTO = App.Data.ABTest.ABTestDTO;
import ABTestPostDTO = App.Data.ABTest.ABTestPostDTO;
import ABTestPatchDTO = App.Data.ABTest.ABTestPatchDTO;

const basePath = "ab-tests";
const baseClient = createApiClient();

export interface PaginationParams {
	page?: number;
	per_page?: number;
}

interface ABTestSearchParams extends PaginationParams {
	sort?: string;
	"filter[name]"?: string;
}

export default class ABTestApi {
	/**
	 * Get all AB tests with optional filtering and pagination
	 */
	getABTests(
		params?: ABTestSearchParams
	): Promise<Result<LaravelPaginatedCollection<ABTestDTO>, ApiError>> {
		return wrapper(baseClient.get(`${basePath}`, { params }));
	}

	/**
	 * Create a new AB test
	 */
	createABTest(abTest: ABTestPostDTO): Promise<Result<void, ApiError>> {
		return wrapper(baseClient.post(`${basePath}`, abTest));
	}

	/**
	 * Get a specific AB test by its ID
	 */
	getABTest(id: string): Promise<Result<ABTestDTO, ApiError>> {
		return wrapper(baseClient.get(`${basePath}/${id}`));
	}

	/**
	 * Update an existing AB test
	 */
	updateABTest(
		id: string,
		abTest: ABTestPatchDTO
	): Promise<Result<ABTestDTO, ApiError>> {
		return wrapper(baseClient.patch(`${basePath}/${id}`, abTest));
	}

	/**
	 * Delete an AB test
	 */
	deleteABTest(id: string): Promise<Result<void, ApiError>> {
		return wrapper(baseClient.delete(`${basePath}/${id}`));
	}
}
